console.log('[Location] script loaded on:', window.location.href);

(function() {
  const saved = localStorage.getItem('userLocation');
  console.log('[Location] localStorage value:', saved);

  if (saved) {
    console.log('[Location] Using cached coords:', JSON.parse(saved));
  } else if (navigator.geolocation) {
    console.log('[Location] Requesting permission...');
    navigator.geolocation.getCurrentPosition(
      pos => {
        const coords = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        localStorage.setItem('userLocation', JSON.stringify(coords));
        console.log('[Location] Saved coords:', coords);
      },
      err => console.warn('[Location] Geolocation error:', err)
    );
  } else {
    console.warn('[Location] Geolocation not supported');
  }
})();


(function() {
    const savedLocation = localStorage.getItem("userLocation");

    if (savedLocation) {
        console.log("Using cached location:", JSON.parse(savedLocation));
    } else if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            function(position) {
                const coords = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                localStorage.setItem("userLocation", JSON.stringify(coords));
                console.log("Location saved:", coords);
            },
            function(error) {
                console.warn("Geolocation error:", error.message);
            }
        );
    }
})();
